/**
 * 术语表项
 */
export interface GlossaryItem {
    chineseTerm: string;
    englishTerm: string;
}

/**
 * 术语表
 * @description 术语表返回内容
 */
export interface Glossary {
    id: string;
    title: string;
    termPair: GlossaryItem[];
}

export const GlossaryService = Symbol('GlossaryService');

/**
 * 反馈服务
 * @description 用于提交反馈
 */
export interface GlossaryService {
    /**
     * @description 获取术语表
     */
    getGlossary(): Promise<Glossary>;

    /**
     * @description 更新术语表
     * @param params 术语表
     */
    updateGlossary(params: Glossary): Promise<void>

    /**
     * @description 导入术语表
     * @param params 术语表 file
     */
    uploadGlossary(params: File): Promise<void>
}
